<template>
    <v-content>
        <v-container fill-height fluid>
            <v-layout align-center justify-center>
                <v-flex lg4 md4 sm8 xs12>
                    <div class="pa-3 form-forgot" v-if="!successForgot">
                        <p class="btn-back">
                            <v-btn flat icon @click="eventBack">
                                <v-img :src="require('../assets/left-arrow-icon.svg')"></v-img>
                            </v-btn>
                        </p>
                        <p class="t1">Forgot Password?</p>
                        <p class="t2">Please enter your email address below, we'll email to you a new password</p>
                        <p class="error-form-inp-2">{{msgError}}</p>
                        <v-form validate v-model="validForm">
                            <p class="t3">Email</p>
                            <v-text-field
                                ref="inpEmail"
                                v-bind:class="{ 'error-form-inp': msgError !== '' }"
                                :rules="[rules.required, rules.email]"
                                placeholder="example@email.com"
                                type="text"
                                solo
                                v-on:keyup="changeInp"
                                v-model="myEmail"
                            ></v-text-field>
                            <v-flex offset-xs9 xs3>
                                <v-btn :loading="loading" :disabled="!validForm" @click="sendPassword" block color="primary" class="btn-forgot">Reset</v-btn>
                            </v-flex>
                        </v-form>
                    </div>
                    <div v-else class="success-forgot">
                        <v-img src="./images/success.png" class="img-ss"></v-img>
                        <div class="info-box">
                            <p class="ss-1">Password reset sent</p>
                            <p class="ss-2">We have emailed your new password. Please check your email for detail.</p>
                            <v-btn @click="eventBack" class="back-login">Back to Login screen</v-btn>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    import UserService from "../services/user.service.js";
export default {
    metaInfo() {
        return {
            title: "Forgot Password User"
        };
    },
    data: () => ({
        UserService: new UserService,
        validForm: true,
        loading: false,
        successForgot: false,
        rules: {
            required: value => !!value || "Required.",
            counter: value => value.length <= 20 || "Max 20 characters",
            email: value => {
                const pattern = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i;
                return pattern.test(value) || "Invalid e-mail.";
            }
        },
        msgError: '',
        myEmail: ''
    }),
    created() {
        this.myEmail = this.$store.getters["auth/emailLogin"];
    },
    computed: {
        /*myEmail() {
            return this.$store.getters["auth/emailLogin"];
        }*/
    },
    methods: {
        login() {
            this.loading = true;
            setTimeout(() => {
                this.$router.push("/dashboard");
            }, 1000);
        },
        sendPassword() {
            this.loading = true;
            this.UserService.resetPassword(this.myEmail).then(res => {
                this.loading = false;
                if (res.data !== undefined && res.data.statusCode === 200) {
                    this.successForgot = true;
                    this.$store.dispatch('auth/setMyEmail', this.myEmail);
                } else {
                    this.msgError = res.data.message;
                }
            });
        },
        eventBack() {
            window.history.length > 1
                ? this.$router.go(-1)
                : this.$router.push('/')
        },
        changeInp() {
            this.msgError = '';
        }
    }
};
</script>
<style>
.form-forgot {
    color: #D0D0D0;
    position: relative;
}
.form-forgot .t1 {
    font-size: 24px;
}
.form-forgot .t2 {
    font-size: 12px;
    width: 100%;
    max-width: 220px;
    margin-bottom: 40px;
}
.form-forgot .t3 {
    text-transform: uppercase;
    font-size: 11px;
    margin-bottom: 8px;
    color: #7E92AA;
}
.form-forgot .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    background-color: #26313E;
}
.form-forgot .v-text-field {
    font-size: 14px;
}
.form-forgot .btn-forgot {
    text-transform: initial;
    font-weight: normal;
}
.form-forgot .theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
    background-color: #0779ff !important;
    color: #fff !important;
}
.form-forgot .v-input__control {
    position: relative;
}
.form-forgot .v-text-field.v-text-field--enclosed .v-text-field__details {
    position: absolute;
    top: -50px;
    padding-left: 0;
}
.form-forgot .theme--light.v-text-field--solo.error--text > .v-input__control > .v-input__slot {
    border: 1px solid #ff5e44;
}
.theme--light.v-btn.v-btn--disabled .v-btn__loading {
    color: #65AAFF !important;
}
.success-forgot {
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    width: 530px;
    height: 245px;
    padding: 50px 40px;
}
.success-forgot .img-ss {
    width: 75px;
    height: 75px;
    margin-right: 35px;
}
.success-forgot .img-ss .v-image__image--cover {
    background-size: 84% auto;
}
.success-forgot .info-box {
    width: 325px;
}
    .ss-1 {
        font-size: 23px;
        color: #5E5E5E;
    }
    .back-login {
        text-transform: initial;
        font-weight: normal;
    }
    .success-forgot .back-login {
        margin-left: 0;
        margin-right: 0;
    }
    .form-forgot .error-form-inp > .v-input__control > .v-input__slot {
        border: 1px solid #FF5E46;
    }
    .error-form-inp-2 {
        color: #FF5E44;
        font-size: 12px;
        position: absolute;
        top: 180px;
    }
    .form-forgot .theme--light.v-input:not(.v-input--is-disabled) input {
        color: #90979e;
    }
    .form-forgot .theme--light.v-input:not(.v-input--is-disabled) input::placeholder {
        color: #90979e;
    }
</style>
